export default class Home {
  constructor({ el }) {
    this.el = el
    this.words = Array.from(this.el.querySelectorAll('.words p'))
    this.currentWord = 0

    this.init()
  }

  init() {
    // fade each word in and out individually on loop
    setInterval(() => {
      this.words[this.currentWord].classList.remove('active')

      this.currentWord = this.currentWord === this.words.length - 1 ? 0 : this.currentWord + 1

      this.words[this.currentWord].classList.add('active')
    }, 3000)
  }
}
